// extracted by mini-css-extract-plugin
module.exports = {"cardClient":"styles_cardClient__JQdfH","imageBackground":"styles_imageBackground__QEc8w","image":"styles_image__A8cfA"};